import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const RefundPolicy = () => {
  return (
    <Container className="my-5">
      <h2 style={{ textAlign: 'center', marginBottom: '20px', marginTop: "90px", color: "#cc9051" }}>Refund Policy</h2>

      <Row className="mb-4 mt-4">
        <Col>
          <h4>All Sales Are Final</h4>
          <p>
            We do not offer refunds, exchanges, or cancellations. Please make sure to carefully review your order before making a payment.
          </p>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h4>Payment Terms</h4>
          <p>
            We accept online payments through credit cards, PayPal, and other available methods. Please note, we do not offer Cash on Delivery (COD) as a payment option.
          </p>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h4>Why No Refunds or Exchanges?</h4>
          <p>
            We are a small, independent art business, and our artwork is carefully crafted and sold in limited quantities. Due to the unique nature of our products, we cannot accept returns or offer exchanges. However, please rest assured that the quality of our products is not compromised, and we strive to deliver what we have promised.
          </p>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h4>What if I Receive a Damaged Product?</h4>
          <p>
            While we take great care in packaging and shipping our artwork, damage can occasionally occur. If you receive a damaged product, please contact us within 3 days of receiving the item. Kindly include photos of the damage, and we will work with you to resolve the issue.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default RefundPolicy;
